/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./sync.vue?vue&type=template&id=ed3954e8&scoped=true"
import script from "./sync.vue?vue&type=script&lang=js"
export * from "./sync.vue?vue&type=script&lang=js"
import style0 from "./sync.vue?vue&type=style&index=0&id=ed3954e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3954e8",
  null
  
)

export default component.exports